import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { useEffect } from 'react';

function ThemeSwitch(_a) {
    var mediaName = _a.mediaName;
    if (window.navigator.userAgent === 'ReactSnap')
        return null;
    var searchParam = new URLSearchParams(window.location.search).get('themeswitch');
    mediaName = searchParam || mediaName || parseHostname().publicationName;
    useEffect(function () {
        var url = "https://interaktiv.tagesanzeiger.ch/static/themes/" + mediaName + ".css";
        var cssLink = window.document.createElement('link');
        cssLink.type = 'text/css';
        cssLink.rel = 'stylesheet';
        cssLink.href = url;
        cssLink.media = 'screen,print';
        window.document.head.appendChild(cssLink);
    }, [mediaName]);
    return null;
}

export default ThemeSwitch;
export { ThemeSwitch };
//# sourceMappingURL=index.js.map
